import { useCursorHandlers } from '../../../contexts/CursorContext/Cursor';
import { useTheme } from '@mui/material/styles';

export const useEditorHandlers = (name: string) => {
  const theme = useTheme();

  return useCursorHandlers({
    name,
    styles: [
      {
        name: 'theme_component_language_menu_button_background_color',
        label: 'Menu button background color',
        type: 'color',
        default: theme.palette.primary.light,
      },
      {
        name: 'theme_component_language_menu_button_down_icon_color',
        label: 'Menu button icon color',
        type: 'color',
        default: theme.palette.primary.contrastText,
      },
      {
        name: 'theme_component_language_menu_button_button_label_color',
        label: 'Menu button label color',
        type: 'color',
        default: theme.palette.primary.contrastText,
      },
      {
        name: 'theme_component_language_menu_paper_background_color',
        label: 'Menu background color',
        type: 'color',
        default: theme.palette.background.paper,
      },
      {
        name: 'theme_component_language_menu_item_color',
        label: 'Menu item text color',
        type: 'color',
        default: theme.palette.text.primary,
      },
    ],
    configuration: [
      {
        name: 'component_language_menu_flags_disabled',
        label: 'Hide the flag icons',
        type: 'checkbox',
        default: false,
      },
      {
        name: 'component_language_menu_the_language_names_disabled',
        label: 'Hide the language names',
        type: 'checkbox',
        default: false,
      },
    ],
  });
}